(function () {
  function formatMoney(cents, format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || "${{amount}}";

    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split(".");
      const dollars = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      const centsPart = parts[1] ? decimal + parts[1] : "";

      return dollars + centsPart;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function createCollapsible(el, initial) {
    let isOpen = initial === undefined ? false : initial;

    el.style.height = isOpen ? "auto" : "0";
    el.style.overflow = "hidden";

    function open() {
      if (isOpen) {
        return;
      }
      isOpen = true;

      const currentHeight = getComputedStyle(el).height;
      el.style.height = "auto";
      const height = getComputedStyle(el).height;
      el.style.height = currentHeight;
      getComputedStyle(el).height;
      requestAnimationFrame(function () {
        el.style.height = height;
      });
    }

    function close() {
      if (!isOpen) {
        return;
      }
      isOpen = false;

      const height = getComputedStyle(el).height;
      el.style.height = height;
      getComputedStyle(el).height;
      requestAnimationFrame(function () {
        el.style.height = "0";
      });
    }

    el.style.transition = "height 300ms ease-in-out";
    el.addEventListener("transitionend", function (e) {
      if (e.target !== el) {
        return;
      }
      if (isOpen) {
        el.style.height = "auto";
      }
    });

    return {
      open: open,
      close: close,
      el: el,
    };
  }

  function updatePrice(el, value, moneyFormat) {
    if (el == null) {
      return;
    }
    el.innerHTML =
      '<span class="money">' + formatMoney(value, moneyFormat) + "</span>";
  }

  function getAllocatedSellingPlanById(variant, id) {
    if (!variant || !variant.sellingPlans) {
      return null;
    }
    return variant.sellingPlans.find(function (plan) {
      return plan.id === Number(id);
    });
  }

  function getProductForms(widget) {
    const formIds = [
      widget.dataset.productFormId,
      widget.dataset.productFormStickyId,
    ].filter(Boolean);

    const forms = formIds
      .map(function (id) {
        return document.getElementById(id);
      })
      .filter(Boolean);

    if (forms.length > 0) {
      return forms;
    }

    return Array.from(document.querySelectorAll('form[action$="/cart/add"]'));
  }

  function getSellingPlanInputs(widget) {
    const associated = Array.from(
      document.querySelectorAll("[data-juo-selling-plan-input]")
    );

    if (associated.length > 0) {
      return associated;
    }

    return getProductForms(widget).map(function (form) {
      let el = form.querySelector('input[name="selling_plan"]');

      if (!el) {
        el = document.createElement("input");
        el.type = "hidden";
        el.name = "selling_plan";
        el.setAttribute("data-juo-selling-plan-input", "");
        form.append(el);
      }

      return el;
    });
  }

  function getActiveVariantId(widget, fallbackVariantId) {
    const formId = widget.dataset.productFormId;
    const form = formId ? document.getElementById(formId) : null;
    const variantInput = form
      ? form.querySelector('input[name="id"]')
      : document.querySelector('form[action$="/cart/add"] input[name="id"]');

    if (variantInput && variantInput.value) {
      return variantInput.value;
    }

    const url = new URL(window.location.href);
    return url.searchParams.get("variant") || fallbackVariantId;
  }

  // --- Kaching Bundles integration -----------------------------------------
  // Kaching adds a quantity-break discount on top of the Juo subscription price.
  // We mirror the resulting cart total (quantity + bundle discount + subscription
  // discount) inside the Juo widget so the displayed price matches the checkout.
  var __kachingDealMap = null;
  var __kachingFetch = null;

  // Kaching loads asynchronously, so its API may not be ready when the widget
  // initialises. We only cache the map once it is successfully populated and
  // otherwise allow later re-tries, guarding against parallel fetches.
  function buildKachingDealMap() {
    if (__kachingDealMap) {
      return Promise.resolve(__kachingDealMap);
    }
    if (__kachingFetch) {
      return __kachingFetch;
    }

    var api = window.kachingBundlesApi;
    if (!api || typeof api.fetchDeals !== "function") {
      return Promise.resolve(null);
    }

    __kachingFetch = Promise.resolve()
      .then(function () {
        return api.fetchDeals();
      })
      .then(function (deals) {
        var map = {};
        (deals || []).forEach(function (deal) {
          (deal.dealBars || []).forEach(function (bar) {
            var pct =
              bar.discount && bar.discount.type === "percentage"
                ? bar.discount.value
                : 0;
            map[bar.id] = { quantity: bar.quantity || 1, discount: pct };
          });
        });
        if (Object.keys(map).length > 0) {
          __kachingDealMap = map;
        }
        __kachingFetch = null;
        return __kachingDealMap;
      })
      .catch(function () {
        __kachingFetch = null;
        return null;
      });

    return __kachingFetch;
  }

  function getActiveKachingDeal() {
    var checked = document.querySelector(
      'input[name^="kaching-bundles-deal"]:checked'
    );
    if (!checked || !__kachingDealMap) {
      return null;
    }
    return __kachingDealMap[checked.value] || null;
  }

  // Kaching applies its percentage per unit and floors the discount in cents
  // before multiplying by the quantity. This matches both the price shown on the
  // Kaching bars and the amount actually charged in the cart/checkout.
  function bundleLineTotal(unitPrice, deal) {
    if (!deal) {
      return unitPrice;
    }
    var perUnit = unitPrice - Math.floor((unitPrice * deal.discount) / 100);
    return perUnit * deal.quantity;
  }

  function initWidget(variants, variantId, moneyFormat) {
    const widget = document.querySelector("#juo-subscription-widget");
    if (!widget) {
      return;
    }

    const sellingPlanInputs = getSellingPlanInputs(widget);
    const priceElement = widget.querySelector('[part="subscription-price"]');
    const basePriceElement = widget.querySelector('[part="price price--base"]');
    const comparePriceElements = widget.querySelectorAll('[part="compare-price"]');
    const subscriptionCompareElement = comparePriceElements[0] || null;
    const otpCompareElement = comparePriceElements[1] || null;
    const sellingPlanSelectorElement = widget.querySelector('[part="select"]');

    function getMode() {
      const checked = widget.querySelector('input[name="mode"]:checked');
      return checked ? checked.value : "otp";
    }

    function getValue() {
      if (getMode() === "otp") {
        return "";
      }

      if (!sellingPlanSelectorElement) {
        const activeVariant = getActiveVariant();
        const firstPlan = activeVariant && activeVariant.sellingPlans[0];
        return firstPlan ? String(firstPlan.id) : "";
      }

      return sellingPlanSelectorElement.value || "";
    }

    function populateSellingPlanId() {
      const value = getValue();
      sellingPlanInputs.forEach(function (sellingPlanInput) {
        sellingPlanInput.value = value;
      });
    }

    function getActiveVariant() {
      const activeVariantId = getActiveVariantId(widget, variantId);
      return (
        variants.find(function (v) {
          return String(v.id) === String(activeVariantId);
        }) || variants.find(Boolean)
      );
    }

    function updateSaveBadge(comparePrice, price) {
      const saveElement = widget.querySelector('[data-ref="save"]');

      if (saveElement) {
        const percentage = (price / comparePrice) * 100;
        saveElement.innerHTML = String(100 - Math.round(percentage));
      }
    }

    function updateSellingPlans(sellingPlans, activeVariantId) {
      if (!sellingPlanSelectorElement) {
        populateSellingPlanId();
        return;
      }

      sellingPlans = sellingPlans || [];

      if (
        sellingPlanSelectorElement.dataset.activeVariant ===
        String(activeVariantId)
      ) {
        return;
      }

      let html = "";
      sellingPlans.forEach(function (plan) {
        html +=
          '<option value="' + plan.id + '">' + plan.name + "</option>";
      });
      sellingPlanSelectorElement.innerHTML = html;

      sellingPlanSelectorElement.dataset.activeVariant = activeVariantId;

      if (sellingPlans.length === 0) {
        sellingPlanSelectorElement.value = "";
        populateSellingPlanId();
        return;
      }

      sellingPlanSelectorElement.value =
        sellingPlanSelectorElement.children[0].value;
      populateSellingPlanId();
    }

    function updateView() {
      const activeVariant = getActiveVariant();
      if (!activeVariant) {
        return;
      }

      const selectedPlanId = sellingPlanSelectorElement
        ? sellingPlanSelectorElement.value
        : getValue();
      const allocatedPlan = getAllocatedSellingPlanById(
        activeVariant,
        selectedPlanId
      );

      updateSellingPlans(activeVariant.sellingPlans, activeVariant.id);

      if (allocatedPlan == null && getMode() === "subscription") {
        widget.classList.add("juo-hidden");
        return;
      }

      widget.classList.remove("juo-hidden");

      if (allocatedPlan && allocatedPlan.comparePrice > allocatedPlan.price) {
        updateSaveBadge(allocatedPlan.comparePrice, allocatedPlan.price);
      }

      const deal = getActiveKachingDeal();
      const quantity = deal ? deal.quantity : 1;

      const otpTotal = bundleLineTotal(activeVariant.price, deal);
      updatePrice(basePriceElement, otpTotal, moneyFormat);

      if (otpCompareElement) {
        const otpOriginal = activeVariant.price * quantity;
        if (deal && deal.discount > 0 && otpOriginal > otpTotal) {
          updatePrice(otpCompareElement, otpOriginal, moneyFormat);
        } else {
          otpCompareElement.innerHTML = "";
        }
      }

      if (allocatedPlan) {
        const subTotal = bundleLineTotal(allocatedPlan.price, deal);
        updatePrice(priceElement, subTotal, moneyFormat);

        const subCompareUnit =
          allocatedPlan.comparePrice > allocatedPlan.price
            ? allocatedPlan.comparePrice
            : allocatedPlan.price;
        const subCompareTotal = subCompareUnit * quantity;

        if (subscriptionCompareElement) {
          if (subCompareTotal > subTotal) {
            updatePrice(
              subscriptionCompareElement,
              subCompareTotal,
              moneyFormat
            );
          } else {
            subscriptionCompareElement.innerHTML = "";
          }
        }
      }
    }

    const collapsibleEl = widget.querySelector(".collapsible");
    const collapsible =
      collapsibleEl == null
        ? null
        : createCollapsible(collapsibleEl, getMode() === "subscription");

    function update() {
      populateSellingPlanId();
      updateView();

      if (collapsible) {
        if (getMode() === "subscription") {
          collapsible.open();
        } else {
          collapsible.close();
        }
      }
    }

    function onVariantChange() {
      if (sellingPlanSelectorElement) {
        sellingPlanSelectorElement.dataset.activeVariant = "";
      }
      update();
    }

    update();

    widget.addEventListener("change", update);
    document.addEventListener("change", function (e) {
      if (
        e.target &&
        e.target.name === "mode" &&
        widget.contains(e.target)
      ) {
        update();
      }
    });

    if (sellingPlanSelectorElement) {
      sellingPlanSelectorElement.addEventListener("change", function () {
        const subscriptionRadio = widget.querySelector(
          'input[name="mode"][value="subscription"]'
        );
        if (subscriptionRadio) {
          subscriptionRadio.checked = true;
        }
        update();
      });
    }

    const sectionId = widget.dataset.sectionId;
    if (sectionId) {
      document.addEventListener(
        "eurus:product-page-variant-select:updated:" + sectionId,
        onVariantChange
      );
    }

    getProductForms(widget).forEach(function (form) {
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.addEventListener("change", onVariantChange);
      }

      form.addEventListener("submit", populateSellingPlanId);
    });

    document.addEventListener("click", function (e) {
      const atcButton = e.target.closest(
        '[id^="x-atc-button-"], .add_to_cart_button, [name="add"]'
      );
      if (!atcButton) {
        return;
      }
      populateSellingPlanId();
    });

    // Re-render the widget price whenever the shopper changes the Kaching bundle
    // (different quantity break / discount), so it keeps matching the cart.
    function watchKaching() {
      let raf = null;
      function schedule() {
        if (raf) {
          return;
        }
        raf = requestAnimationFrame(function () {
          raf = null;
          buildKachingDealMap().then(update);
        });
      }

      document.addEventListener("change", function (e) {
        if (e.target && /^kaching-bundles-deal/.test(e.target.name || "")) {
          schedule();
        }
      });

      let attempts = 0;
      (function attachObserver() {
        const container = document.querySelector(".kaching-bundles__bars");
        if (!container) {
          if (attempts++ < 20) {
            setTimeout(attachObserver, 300);
          }
          return;
        }
        try {
          const observer = new MutationObserver(schedule);
          observer.observe(container, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ["class", "checked", "aria-checked"],
          });
        } catch (e) {
          /* MutationObserver unsupported */
        }
        schedule();
      })();

      // Kaching selects its default bar asynchronously after we initialise, and
      // may set the radio via a property (no event). Re-sync a few times so the
      // initial total is correct without relying solely on the observer.
      [200, 600, 1200, 2500].forEach(function (t) {
        setTimeout(schedule, t);
      });
    }

    buildKachingDealMap().then(function () {
      update();
      watchKaching();
    });
  }

  function getActiveJuoSellingPlanId() {
    const inputs = Array.from(
      document.querySelectorAll(
        'input[name="selling_plan"][data-juo-selling-plan-input]'
      )
    );
    const active = inputs.find(function (input) {
      return input.value;
    });
    return active ? active.value : "";
  }

  // Bundle apps (e.g. Kaching Bundles) can intercept the add-to-cart button and
  // rebuild the request as a JSON payload, silently dropping the "selling_plan"
  // field so the subscription is lost. We re-inject the active selling plan into
  // any /cart/add request while the widget is in subscription mode.
  function installCartAddInterceptor() {
    if (window.__juoCartAddInterceptor || typeof window.fetch !== "function") {
      return;
    }
    window.__juoCartAddInterceptor = true;

    const originalFetch = window.fetch;

    function injectSellingPlan(bodyString, sellingPlanId) {
      let data;
      try {
        data = JSON.parse(bodyString);
      } catch (e) {
        return bodyString;
      }

      const planId = parseInt(sellingPlanId, 10);
      if (isNaN(planId)) {
        return bodyString;
      }

      if (data && Array.isArray(data.items)) {
        data.items.forEach(function (item) {
          if (item && item.selling_plan == null) {
            item.selling_plan = planId;
          }
        });
      } else if (data && data.id != null && data.selling_plan == null) {
        data.selling_plan = planId;
      } else {
        return bodyString;
      }

      return JSON.stringify(data);
    }

    window.fetch = function (input, init) {
      try {
        const url =
          typeof input === "string"
            ? input
            : input && input.url
            ? input.url
            : "";

        if (
          url &&
          /\/cart\/add(\.js)?(\?|$)/.test(url) &&
          init &&
          typeof init.body === "string"
        ) {
          const sellingPlanId = getActiveJuoSellingPlanId();
          if (sellingPlanId) {
            const newBody = injectSellingPlan(init.body, sellingPlanId);
            if (newBody !== init.body) {
              init = Object.assign({}, init, { body: newBody });
              arguments[1] = init;
            }
          }
        }
      } catch (e) {
        /* fall through to the original request */
      }

      return originalFetch.apply(this, arguments);
    };
  }

  function main() {
    installCartAddInterceptor();

    if (window.Shopify != null) {
      function init() {
        const dataEl = document.getElementById("juo-subscription-widget-data");
        if (!dataEl) {
          return;
        }

        const parsed = JSON.parse(dataEl.innerText || "[]");
        const variants = parsed[0];
        const variantId = parsed[1];
        const moneyFormat = parsed[2];

        if (!variants || !variants.length) {
          return;
        }

        initWidget(variants, variantId, moneyFormat);
      }

      if (
        document.readyState === "complete" ||
        document.readyState === "interactive"
      ) {
        init();
      } else {
        document.addEventListener("DOMContentLoaded", init);
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", main);
  } else {
    main();
  }
})();
